import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors, TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const lightTheme = {
  root: {
    '& $tabs': {
      color: TextColors.dark,
      '& .MuiTabs-indicator': {
        backgroundColor: SecondaryColors.dark,
      },
    },
    '& $tab': {
      color: TextColors.dark,
      '&.MuiTab-textColorInherit': {
        color: TextColors.dark,

        '&.Mui-selected, &:hover': {
          color: TextColors.dark,
        },
      },
    },
    '& $superheading': {
      color: SecondaryColors.dark,
    },
    '& $rtc': {
      color: hexToRGBA(TextColors.dark, TextOpacities.light2),

      '& b, & strong': {
        color: TextColors.dark,
      },
    },
  },
};
const darkTheme = {
  root: {
    '& $tabs': {
      color: TextColors.light,
      '& .MuiTabs-indicator': {
        backgroundColor: SecondaryColors.main,
      },
    },
    '& $tab': {
      color: TextColors.light,
      '&.MuiTab-textColorInherit': {
        color: TextColors.light,

        '&.Mui-selected, &:hover': {
          color: TextColors.light,
        },
      },
    },
    '& $superheading': {
      color: SecondaryColors.main,
    },
    '& $rtc': {
      color: hexToRGBA(TextColors.light, TextOpacities.dark2),

      '& b, & strong': {
        color: TextColors.light,
      },
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
      '& .columns': {
        alignItems: 'center',
        alignContent: 'center',

        '& .right-column': {
          flexShrink: 0,
        },

        [muiTheme.breakpoints.down('sm')]: {
          display: 'flex',
          flexDirection: 'column-reverse',
        },

        '& > *:not(:last-child)': {
          [muiTheme.breakpoints.down('sm')]: {
            marginBottom: 0,
          },
        },

        '& > *:not(:first-child)': {
          [muiTheme.breakpoints.down('sm')]: {
            marginBottom: muiTheme.spacing(4),
          },
        },
      },
    },
    tabs: {
      position: 'relative',
      display: 'inline-flex',
      padding: '2px',

      '&': {
        [muiTheme.breakpoints.down('sm')]: {
          margin: '-2px -2px -2px -32px',
          width: 'calc(100% + 64px)',
        },

        [muiTheme.breakpoints.up('md')]: {
          margin: '22px -2px -2px -2px',
          width: 'calc(100% + 4px)',
        },
      },

      [muiTheme.breakpoints.down('sm')]: {
        margin: '22px -2px -2px -32px',
        width: 'calc(100% + 68px)',
      },

      '& .MuiTabs-flexContainer': {
        position: 'relative',
        zIndex: 1,
      },

      '& .MuiTabs-scrollButtons': {
        width: '32px',
      },

      '& .MuiTabs-indicator': {
        zIndex: 1,
      },
    },
    tabImage: {
      width: '100%',
      height: '100%',
    },
    tab: {
      borderRadius: '4px',
      minWidth: '0',
      whiteSpace: 'nowrap',
      padding: muiTheme.spacing(3),

      '&': {
        [muiTheme.breakpoints.down('xs')]: {
          width: 'calc(50% - 12px)',
          height: muiTheme.spacing(12),
        },

        [muiTheme.breakpoints.up('sm')]: {
          width: 'calc(25% - 18px)',
          height: muiTheme.spacing(13),
        },
      },

      '&:not(:last-child)': {
        marginRight: '24px',
      },

      [muiTheme.breakpoints.up('sm')]: {
        width: 'calc(25% - 18px)',
      },

      '&.Mui-selected': {
        borderRadius: '4px 4px 0 0',
      },

      '&.MuiTab-textColorInherit': {
        opacity: 0.5,

        '&.Mui-selected, &:hover': {
          opacity: 1,
        },
      },
    },
    tabPanelAnimated: {
      '& > *': {
        animation: 'enter 250ms ease-out',
      },
    },
    tabPanel: {
      '& > * + *': {
        marginTop: muiTheme.spacing(2),
      },
    },
    superheading: {
      '&.MuiTypography-root': {
        marginBottom: muiTheme.spacing(2),
      },
    },
    heading: {
      '& p, & h1, & h2, & h3, & h4, & h5, & h6': {
        ...muiTheme.typography.h4,
      },
    },
    rtc: {},
    link: {
      marginTop: muiTheme.spacing(4),
    },
    media: {
      '& + *': {
        marginTop: muiTheme.spacing(2),
      },
    },
  }),
  { name: 'GenComplexTabsHorizontalLogos' },
);

export default useStyles;
